import { useState } from 'react';
import { FaTimes, FaExpand } from 'react-icons/fa';
import { useLanguage } from '../i18n';

const Portfolio = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const { language, t } = useLanguage();

  const portfolioItems = [
    { id: 1, title: 'Background 9 Concept', image: '/gallery/Backgrund 9 Concept.png' },
    { id: 2, title: 'Plano 07', image: '/gallery/Plano_07.png' },
    { id: 3, title: 'Plano 09', image: '/gallery/Plano_09.png' },
    { id: 4, title: 'Plano 12', image: '/gallery/Plano_12.png' },
    { id: 5, title: 'Plano 15', image: '/gallery/Plano_15.png' },
    { id: 6, title: 'Plano 29', image: '/gallery/Plano_29.png' },
    { id: 7, title: 'Plano 31', image: '/gallery/Plano_31.png' },
    { id: 8, title: 'Arte de escenario', image: '/gallery/Plano_35.png' },
    { id: 9, title: 'Arena de DeadJavu', image: '/gallery/deadjavu-arena.png', contain: true },
    { id: 10, title: 'Animación idle de Nikola', image: '/gallery/deadjavu-nikola-idle.png', contain: true },
    { id: 11, title: 'Animación de derrota de Nikola', image: '/gallery/deadjavu-nikola-dead.png', contain: true },
    { id: 12, title: 'Personaje de DeadJavu', image: '/gallery/deadjavu-character.png', contain: true },
    { id: 13, title: 'Concepto de personaje', image: '/gallery/character-concept.png', contain: true },
    { id: 14, title: 'Animación de elevador', image: '/gallery/elevator-animation.gif', contain: true },
    { id: 15, title: 'Animación de escenario urbano', image: '/gallery/street-animation.gif', contain: true },
    { id: 16, title: 'Animación de grupo', image: '/gallery/group-animation.gif', contain: true },
    { id: 17, title: 'Animación de personaje', image: '/gallery/character-animation.gif', contain: true }
  ];

  const openModal = (item) => {
    setSelectedItem(item);
  };

  const closeModal = () => {
    setSelectedItem(null);
  };

  return (
    <section id="portfolio" className="section-shell min-h-screen px-4 py-12 sm:py-16 lg:py-20">
      <div className="section-content max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="section-title text-3xl sm:text-4xl md:text-5xl font-black mb-4 sm:mb-6">
            {t('portfolio')}
          </h2>
          <p className="text-lg sm:text-xl text-purple-200 max-w-3xl mx-auto px-4">
            {language === 'es' ? 'Bocetos, escenarios y material visual de nuestros proyectos.' : 'Sketches, environments and visual material from our projects.'}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-12 sm:mb-16">
          {portfolioItems.map((item) => (
            <button
              key={item.id}
              type="button"
              className="modern-panel relative group cursor-pointer overflow-hidden rounded-xl border transition-all duration-300 transform hover:-translate-y-1 text-left"
              onClick={() => openModal(item)}
            >
              <div className="aspect-square bg-black/20 flex items-center justify-center">
                <img
                  src={item.image}
                  alt={item.title}
                  className={`w-full h-full ${item.contain ? 'object-contain p-2 [image-rendering:pixelated]' : 'object-cover'} transition-transform duration-500 group-hover:scale-105`}
                />
              </div>
              <div className="absolute right-3 top-3 bg-black/55 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <FaExpand className="text-sm" />
              </div>
            </button>
          ))}
        </div>

        {selectedItem && (
          <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-2 sm:p-4">
            <div className="relative max-w-4xl w-full max-h-[90vh] sm:max-h-[85vh]">
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 sm:top-4 sm:right-4 text-white hover:text-purple-300 transition-colors z-10 bg-black/60 rounded-full p-2 sm:p-3"
                aria-label={language === 'es' ? 'Cerrar imagen' : 'Close image'}
              >
                <FaTimes size={20} className="sm:w-6 sm:h-6" />
              </button>

              <div className="modern-panel rounded-xl p-2 sm:p-4">
                <div className="flex items-center justify-center">
                  <img
                    src={selectedItem.image}
                    alt={selectedItem.title}
                    className={`max-w-full max-h-[60vh] sm:max-h-[70vh] object-contain rounded-lg ${selectedItem.contain ? '[image-rendering:pixelated]' : ''}`}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Portfolio;
